import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  MeetingRoutingRuleRequest,
  MeetingRoutingRuleResponse,
  PageResponse,
} from '../models/meeting.model';

@Injectable({ providedIn: 'root' })
export class MeetingRoutingRuleApiService {
  private url = `${environment.apiUrl}api/meeting-routing-rules`;
  constructor(private http: HttpClient) {}

  list(
    businessId: number,
    page = 0,
    size = 20
  ): Observable<PageResponse<MeetingRoutingRuleResponse>> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<MeetingRoutingRuleResponse>>(this.url, {
      params,
    });
  }

  listActive(idBookingLink: number): Observable<MeetingRoutingRuleResponse[]> {
    const params = new HttpParams().set(
      'idBookingLink',
      idBookingLink.toString()
    );
    return this.http.get<MeetingRoutingRuleResponse[]>(`${this.url}/active`, {
      params,
    });
  }

  getById(
    id: number,
    businessId: number
  ): Observable<MeetingRoutingRuleResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<MeetingRoutingRuleResponse>(`${this.url}/${id}`, {
      params,
    });
  }

  create(
    body: MeetingRoutingRuleRequest
  ): Observable<MeetingRoutingRuleResponse> {
    return this.http.post<MeetingRoutingRuleResponse>(this.url, body);
  }

  update(
    id: number,
    businessId: number,
    body: MeetingRoutingRuleRequest
  ): Observable<MeetingRoutingRuleResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<MeetingRoutingRuleResponse>(
      `${this.url}/${id}`,
      body,
      { params }
    );
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.url}/${id}`, { params });
  }
}
